<kendo-dialog
  title="Sync the following changes"
  (close)="onCancel()"
  [width]="width"
  [height]="height"
>
  <div class="sync-options">
    <div class="sync-lab-container">
      <input
        #lab
        kendoRadioButton
        type="radio"
        name="syncOption"
        [(ngModel)]="syncOption"
        (change)="onSyncOptionChange('lab')"
        value="lab"
      />
      <kendo-label [for]="lab">Schedule to lab only</kendo-label>
    </div>

     <div class="schedule-sync-container">
      <input
        #now
        kendoRadioButton
        type="radio"
        name="syncOption"
        [(ngModel)]="syncOption"
        (change)="onSyncOptionChange('now')"
        value="now"
      />
      <kendo-label [for]="now">Sync now </kendo-label>
    </div>

    <div class="schedule-sync-container">
      <input
        #scheduled
        kendoRadioButton
        type="radio"
        name="syncOption"
        [(ngModel)]="syncOption"
        (change)="onSyncOptionChange('scheduled')"
        value="scheduled"
      />
      <kendo-label [for]="scheduled">Schedule sync </kendo-label>
      <kendo-datetimepicker
        adaptiveMode="auto"
        *ngIf="syncOption == 'scheduled'"
        class="schedule-datepicker"
        [(ngModel)]="scheduledDate"
      ></kendo-datetimepicker>
    </div>
  </div>

  <kendo-tabstrip [keepTabContent]="true">
    <!-- Hide Pricing Changes tab for AvailabilityOnly users -->
    <kendo-tabstrip-tab
      *ngIf="isAvailabilityOnly != null && !isAvailabilityOnly"
      [selected]="pricingCount > 0"
    >
      <ng-template kendoTabTitle>
        Pricing Changes ({{ pricingCount }})
      </ng-template>
      <ng-template kendoTabContent>
        <app-pending-changes-grid
          [labOnly]="syncOption == 'lab'"
          #pricingGrid
          [type]="'pricing'"
        ></app-pending-changes-grid>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab
      [selected]="
        (isAvailabilityOnly || pricingCount == 0) && availabilityCount > 0
      "
    >
      <ng-template kendoTabTitle>
        Availability Changes ({{ availabilityCount }})
      </ng-template>
      <ng-template kendoTabContent>
        <app-pending-changes-grid
          [labOnly]="syncOption == 'lab'"
          #availabilityGrid
          [type]="'availability'"
        ></app-pending-changes-grid>
      </ng-template>
    </kendo-tabstrip-tab>

    <!-- Hide Custom Changes tab for AvailabilityOnly users -->
    <kendo-tabstrip-tab
      *ngIf="isAvailabilityOnly != null && !isAvailabilityOnly"
      [selected]="
        pricingCount == 0 && availabilityCount == 0 && overridesCount > 0
      "
    >
      <ng-template kendoTabTitle>
        Custom Changes ({{ overridesCount }})
      </ng-template>
      <ng-template kendoTabContent>
        <app-pending-changes-grid
          [labOnly]="syncOption == 'lab'"
          #overrideGrid
          [type]="'overrides'"
        ></app-pending-changes-grid>
      </ng-template>
    </kendo-tabstrip-tab>
    
      <kendo-tabstrip-tab
          *ngIf="isAvailabilityOnly != null && !isAvailabilityOnly && modifierCodesFeatureEnabled"
          [selected]="pricingCount == 0 && availabilityCount == 0 && overridesCount == 0 && modifierCodesCount > 0"
        >
          <ng-template kendoTabTitle>
            Modifier Codes Changes ({{ modifierCodesCount }})
          </ng-template>
          <ng-template kendoTabContent>
            <app-pending-changes-grid
              [labOnly]="syncOption == 'lab'"
              #modifierCodesGrid
              [type]="'modifiercodes'"
            ></app-pending-changes-grid>
          </ng-template>
        </kendo-tabstrip-tab>
  </kendo-tabstrip>

  <kendo-dialog-actions layout="end">
    <kendo-checkbox
      class="m-t-2"
      #downloadBackupCheckbox
      [checkedState]="downloadBackup"
      (checkedStateChange)="downloadBackup = $event"
    ></kendo-checkbox>
    <kendo-label
      class="k-checkbox-label"
      [for]="downloadBackupCheckbox"
      text="Download Backup"
    ></kendo-label>
    <button kendoButton (click)="onCancel()">Cancel</button>
    <button kendoButton (click)="showSyncWarning = true" themeColor="primary">
      Sync
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  [width]="700"
  *ngIf="showSyncWarning"
  (close)="showSyncWarning = false"
>
  <kendo-dialog-titlebar>
    <fa-icon class="error" [icon]="['fas', 'exclamation-circle']"></fa-icon>
    <span *ngIf="syncOption == 'lab'"> Sync to Lab Only? </span>
    <span *ngIf="syncOption != 'lab'">
      Please confirm
    </span>
  </kendo-dialog-titlebar>
  <span *ngIf="syncOption != 'lab'">
    <p>
        Current tier will be locked for pricing changes until we 
        receive confirmation that your change made it to the POS terminal.
    </p>
    <p *ngIf="syncOption != 'now'">
        Please confirm time and date for this sync in calendar.
    </p>
    <p><strong>Are you sure you want to sync<span *ngIf="syncOption == 'now'"> now</span>?</strong></p>
  </span>

  <span *ngIf="syncOption == 'lab'">
    <p>These changes will only be synced to the lab POS.</p>

    <p>
      Your changes will still be available for you to sync to a tier when you
      are ready.
    </p>
  </span>
  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="showSyncWarning = false">No</button>
    <button kendoButton (click)="onAccept()" themeColor="error">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
